module.exports = __webpack_public_path__ + "static/media/antelope@3x.9bbffae7.jpg";